import { useState } from 'react';
function TaskList() {
	const [tasks, setTasks] = useState(['Task 1', 'Task 2', 'Task 3']);

	const removeTask = taskIndex => {
		const newTasks = tasks.filter((_, index) => index !== taskIndex);
		setTasks(newTasks);
	};

	return (
		<div>
			{tasks.map((task, index) => (
				<TaskItem key={index} task={task} onRemove={() => removeTask(index)} />
			))}
		</div>
	);
}

function TaskItem({ task, onRemove }) {
	return (
		<div>
			<p>{task}</p>
			<button onClick={onRemove}>Remove</button>
		</div>
	);
}
export default TaskList